export default __webpack_public_path__ + "static/media/footer-logo.057c5a2d.webp";